'use client'

import React from 'react'

import { I18nContext } from './provider'

export function useI18n() {
    const context = React.use(I18nContext)

    if (context === null) {
        throw new Error('useI18n must be used within a I18nProvider')
    }

    return context
}
